export default "__VITE_ASSET__Dp5pq0lR__"